import {BACKEND_API} from '../middleware/backend'

export const TREATMENTS_REQUEST = 'TREATMENTS_REQUEST';
export const TREATMENTS_SUCCESS = 'TREATMENTS_SUCCESS';
export const TREATMENTS_FAILURE = 'TREATMENTS_FAILURE';
export const TREATMENTS_COUNT_REQUEST = 'TREATMENTS_COUNT_REQUEST';
export const TREATMENTS_COUNT_SUCCESS = 'TREATMENTS_COUNT_SUCCESS';
export const TREATMENTS_COUNT_FAILURE = 'TREATMENTS_COUNT_FAILURE';
export const TREATMENT_REQUEST = 'TREATMENT_REQUEST';
export const TREATMENT_SUCCESS = 'TREATMENT_SUCCESS';
export const TREATMENT_FAILURE = 'TREATMENT_FAILURE';
export const TREATMENT_SAVE_REQUEST = 'TREATMENT_SAVE_REQUEST';
export const TREATMENT_SAVE_SUCCESS = 'TREATMENT_SAVE_SUCCESS';
export const TREATMENT_SAVE_FAILURE = 'TREATMENT_SAVE_FAILURE';
export const TREATMENT_INFO_REQUEST = 'TREATMENT_INFO_REQUEST';
export const TREATMENT_INFO_SUCCESS = 'TREATMENT_INFO_SUCCESS';
export const TREATMENT_INFO_FAILURE = 'TREATMENT_INFO_FAILURE';

export const loadTreatments = (filter) => (dispatch, getState) => {
	return dispatch({
		[BACKEND_API]: {
			types: [TREATMENTS_REQUEST, TREATMENTS_SUCCESS, TREATMENTS_FAILURE],
			endpoint: "treatment/list",
			filter: filter
		}
	})
};

export const countTreatments = (filter) => (dispatch, getState) => {
	return dispatch({
		[BACKEND_API]: {
			types: [TREATMENTS_COUNT_REQUEST, TREATMENTS_COUNT_SUCCESS, TREATMENTS_COUNT_FAILURE],
			endpoint: "treatment/count",
			filter: filter
		}
	})
};

export const loadTreatment = (id) => (dispatch, getState) => {
	return dispatch({
		id: id,
		[BACKEND_API]: {
			types: [TREATMENT_REQUEST, TREATMENT_SUCCESS, TREATMENT_FAILURE],
			endpoint: `treatment/${id}`,
		}
	})
};

export const saveTreatment = (treatment) => (dispatch, getState) => {
	return dispatch({
		id: treatment.treatmentId,
		treatment: treatment,
		[BACKEND_API]: {
			types: [TREATMENT_SAVE_REQUEST, TREATMENT_SAVE_SUCCESS, TREATMENT_SAVE_FAILURE],
			endpoint: 'treatment',
			body: treatment,
			silent: true
		}
	})
};

export const loadTreatmentInfo = (id) => (dispatch, getState) => {
	return dispatch({
		id: id,
		[BACKEND_API]: {
			types: [TREATMENT_INFO_REQUEST, TREATMENT_INFO_SUCCESS, TREATMENT_INFO_FAILURE],
			endpoint: `treatment/info/${id}`,
		}
	})
};



// WEBPACK FOOTER //
// ./src/actions/treatments.js